<template>
    <div>
        <ArrayBeam v-bind:date_str="selectedDate"></ArrayBeam>
        <div class="row justify-content-center row-cols-3" style="">
            <ProductsView  v-for="entry in entries" v-bind:key="entry.id" v-bind:time_chunk="entry.time_chunks"
                          v-bind:sap="entry.sap"
                          v-bind:title="entry.title"></ProductsView>
        </div>
    </div>
</template>


<script>
import ProductsView from "./ProductsView";
import axios from 'axios';
import ArrayBeam from "@/components/ArrayBeam";

export default {
    name: "ProductsList",
    components: {
        ArrayBeam,
        ProductsView,
    },
    props: {
        'selectedDate': String,
        'selectedBeam': String,
    },
    data() {
        return {
            entries: []
        }
    },
    mounted() {
        if (this.selectedDate == null) {
            this.entries = [
                {
                    id: 'date_not_selected',
                    title: 'select date',
                    time_chunks: []
                }
            ]
        } else {
            this.fetchData(this.selectedDate, null);
        }
    },
    methods: {
        fetchData: function (date, beam) {
            if (date == null) {
                console.log('Date is null wtf!')
            }
            let url = 'https://spaceweather.astron.nl/api/tasks/'
            let query = ''
            if (date != null) {
                query += 'date=' + date
            }
            if (beam != null) {
                if (query !== '') {
                    query += '&'
                }
                query += 'beam=' + beam
            }
            if (query !== '') {
                url += '?' + query
            }
            axios
                .get(url)
                .then(response => {
                    let data = response.data;
                    this.entries = []

                    data = data.map(x => {
                        return {...x, sap: x.source.match(/SAP([0-9]*)/)[1]}
                    }).sort((a, b) => {return (a.sap > b.sap ? 1 : -1)})


                    for (let name in data) {
                        this.entries.push({
                            id: name,
                            title: name,
                            sap: Number(data[name].source.match(/SAP([0-9]*)/)[1]),
                            time_chunks: data[name]
                        })
                    }
                })

        }
    },
    watch: {
        selectedDate: function (val) {
            this.fetchData(val, this.selectedBeam);
        },
        selectedBeam: function (val) {
            this.fetchData(this.selectedDate, val)
        }
    }
}
</script>

<style scoped>

</style>